import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'logBehavior',
    label: 'Log Behavior',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
